import LyDeleteButton from './src/index.vue'

LyDeleteButton.install = function (Vue) {
    Vue.component(LyDeleteButton.name, LyDeleteButton)
}

export default LyDeleteButton



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/delete-button/index.js
// module id = null
// module chunks = 